import * as actions from './actions';

export default {
  getBalance: actions.getBalance,
  connect: actions.openFrame,
  logOut: actions.logOut,
};